export class ImpersonateUserConstants {
    public static MORE_INFO = 'more-info';
    public static MORE_OPTIONS = 'more-options';
    public static ID = 'id';
    public static TOP = 'top';
    public static RIGHT = 'right';
}


// WEBPACK FOOTER //
// ./src/app/customerservice/constants/impersonate-user.constants.ts